<div [hidden]="!showTotalVolumes()">
  <rask-list [data]="tableDataTotalAOVolumes">
    <rask-list-column header="TT" field="tt"></rask-list-column>
    <rask-list-column header="GT" field="gt"></rask-list-column>
    <rask-list-column header="kTT" field="ktt"></rask-list-column>
    <rask-list-column header="kGT" field="kgt"></rask-list-column>
    <rask-list-column header="B-mav" field="bmav"></rask-list-column>
    <rask-list-column header="L-mav" field="lmav"></rask-list-column>
    <rask-list-column header="Total" field="total"></rask-list-column>
  </rask-list>
</div>

@if (localArbetsorderList && localArbetsorderList?.length) {
  <div id="rask-arbetsorderlista" [style]="{'height': listHeight + 'px'}">
    <cdk-virtual-scroll-viewport minBufferPx="846" maxBufferPx="940" [itemSize]="94" [style]="{'height': listHeight + 'px'}">
      <div *cdkVirtualFor="let arbetsorder of localArbetsorderList; trackBy: aoIndex; templateCacheSize: 20" >
        <rask-arbetsorder-header [arbetsorder]="arbetsorder" [isDetailedView]="false">
        </rask-arbetsorder-header>
      </div>
    </cdk-virtual-scroll-viewport>
  </div>
}
@if (isSearchResult && !localArbetsorderList?.length) {
  <div class="ps-3">Inga arbetsordrar hittades</div>
}
@if (!isSearchResult) {
  <div class="ps-3">Var god genomför en sökning ovanför</div>
}
